export const $scrollIntoView = (code, options = {
    behavior: 'smooth',
    block: 'center'
}) => {
    if (document.querySelector(code)) {
        document.querySelector(code).scrollIntoView(options)
    }
}
